import { render } from "./CoveringMessage.vue?vue&type=template&id=60184612&scoped=true"
import script from "./CoveringMessage.vue?vue&type=script&lang=js"
export * from "./CoveringMessage.vue?vue&type=script&lang=js"

import "./CoveringMessage.vue?vue&type=style&index=0&id=60184612&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60184612"

export default script